@if ({ activityState: activityState$ | async, loadingStatus: isLoading$ | async }; as vm) {
<div (scroll)="onScrollDiv($event)" #curriculumScrollContainer class="scroll-container-height scroll-container">
  @if (isDefaultView()) {
  <app-course-header [courseState]="courseState" (clickEvent)="actionEvent($event)"></app-course-header>
  } @if ({course: course$ | async }; as vm) {
  <div class="px-4">
    <!-- (changeHistory)="changeHistoryDrawer.open()" -->
    <app-course-heading>
      <ng-container actions>
        @if (isDefaultView()) {
        <button class="btn-outline btn-sm">
          <svg-icon src="@assets/images/icons/play-circle.svg" class="btn-icon"></svg-icon>
          <span>Student Preview</span>
        </button>
        <button class="btn-black btn-sm">
          <svg-icon src="@assets/images/icons/play-circle.svg" class="btn-icon"></svg-icon>
          <span>Instructor Preview</span>
        </button>
        } @if (isDefaultView() && vm.course?.is_latest) { @if (courseState === '0') {
        <button class="btn btn-sm rounded-lg bg-green-500 text-green-100" (click)="actionEvent('edit')">
          <svg-icon src="@assets/images/icons/pencil.svg" class="btn-icon"></svg-icon>
          <span>Edit</span>
        </button>
        } @if (courseState === '1') {
        <button class="btn btn-outline btn-sm rounded-lg" (click)="actionEvent('cancel')">
          <span>Cancel</span>
        </button>
        } }
      </ng-container>
    </app-course-heading>
  </div>
  }
  <div class="course-intended relative p-4">
    @if (vm.loadingStatus === 'loading') {
    <div
      class="absolute left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-white bg-opacity-25"
      [thkLibProcessing]="true"
      size="md"
    ></div>
    } @else { @if (isDefaultView()) {
    <app-common-tab-menu [items]="tabItems" title="Overview"></app-common-tab-menu>
    }
    <div>
      <div class="card mb-4 block rounded-[10px] border border-neutral-100 px-6 py-9">
        <!-- component -->
        @if (isLoading()) {
        <!-- Loader -->
        <div class="flex h-64 items-center justify-center" [thkLibProcessing]="true"></div>
        } @if (hasNoData()) {
        <!-- Empty State -->
        <div class="flex h-64 items-center justify-center text-slate-500" i18n>
          No sessions available for this course.
        </div>
        } @if (hasData()) {
        <!-- single_session -->
        @if(this.course()?.course_mode === 'single_session' || this.course()?.course_mode === 'freestyle') {
        <!-- Table Section -->
        <div class="flex flex-col">
          <div class="w-full rounded-xl">
            <table class="w-full min-w-[700px] border-separate border-spacing-y-4 text-sm">
              <thead class="bg-slate-100 text-xs">
                <tr class="">
                  <th class="rounded-bl-lg rounded-tl-lg p-4 text-left font-medium text-slate-600" i18n>Session</th>
                  <th class="p-4 text-left font-medium text-slate-600" i18n>Time</th>
                  <th class="p-4 text-center font-medium text-slate-600" i18n>Duration</th>
                  <th class="p-4 text-center font-medium text-slate-600">
                    <div class="flex items-center justify-center gap-1">
                      <svg-icon class="h-4 w-4" src="@assets/images/icons/checkmark-square.svg"></svg-icon>
                      <span i18n>Available Seats</span>
                    </div>
                  </th>
                  <th class="p-4 text-center font-medium text-slate-600">
                    <div class="flex items-center justify-center gap-1">
                      <svg-icon class="h-4 w-4 text-slate-400" src="@assets/images/icons/user-group.svg"></svg-icon>
                      <span i18n>Enrolled</span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody
                class="[&_tr:hover]:shadow-md [&_tr]:rounded-xl [&_tr]:border [&_tr]:border-slate-50 [&_tr]:bg-white [&_tr]:shadow [&_tr]:transition-all [&_tr]:duration-150"
              >
                @for(session of sessions(); track session?.id; ){
                <tr
                  class="rounded-xl transition-all duration-150 hover:shadow-md"
                  [class]="session.status === 'CANCELLED' ? 'bg-red-50/50 hover:bg-red-50' : 'hover:bg-slate-50'"
                >
                  <!-- Session Name + Flags + Status -->
                  <td class="rounded-l-xl px-4 py-3">
                    <div class="flex flex-col" [class.opacity-60]="session.status === 'CANCELLED'">
                      <div class="flex flex-wrap items-center gap-2">
                        <span
                          class="text-sm font-medium"
                          [class.text-slate-400]="session.status === 'CANCELLED'"
                          [class.line-through]="session.status === 'CANCELLED'"
                          [class.text-slate-800]="session.status !== 'CANCELLED'"
                          >Session {{ ($index + 1).toString().padStart(2, '0') }}</span
                        >

                        <!-- Makeup icon (star-solid) -->
                        @if (session.is_make_up_class) {
                        <svg-icon
                          src="@assets/images/icons/star-solid.svg"
                          class="h-3.5 w-3.5 text-purple-500"
                          title="Makeup Session"
                        ></svg-icon>
                        }

                        <!-- Rescheduled icon (refresh) - only show when rescheduled_to is null and not cancelled -->
                        @if (session.rescheduled_from && !session.rescheduled_to && session.status !== 'CANCELLED') {
                        <svg-icon
                          src="@assets/images/icons/refresh.svg"
                          class="h-3.5 w-3.5 text-blue-600"
                          title="Rescheduled"
                        ></svg-icon>
                        }

                        <!-- Temporal Status Badge (only for non-cancelled) -->
                        @if (session.status !== 'CANCELLED' && session.temporal_status) {
                        <span
                          class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold"
                          [class.bg-green-100]="session.temporal_status === 'upcoming'"
                          [class.text-green-600]="session.temporal_status === 'upcoming'"
                          [class.bg-slate-100]="session.temporal_status === 'completed'"
                          [class.text-slate-500]="session.temporal_status === 'completed'"
                          [class.bg-amber-100]="session.temporal_status === 'in_progress'"
                          [class.text-amber-600]="session.temporal_status === 'in_progress'"
                        >
                          <span class="h-1.5 w-1.5 rounded-full bg-current"></span>
                          <span class="capitalize">{{ session.temporal_status }}</span>
                        </span>
                        }

                        <!-- Cancelled Badge -->
                        @if (session.status === 'CANCELLED') {
                        <span
                          class="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-600"
                        >
                          <span class="h-1.5 w-1.5 rounded-full bg-current"></span>
                          <span i18n>Cancelled</span>
                        </span>
                        }
                      </div>
                      <div class="mt-0.5 flex items-center gap-1 text-xs text-slate-500">
                        <svg-icon class="h-4 w-4" src="@assets/images/icons/calendar.svg"></svg-icon>
                        <span [class.line-through]="session.status === 'CANCELLED'">{{
                          session.start_datetime | date : 'dd MMMM' : timeZone()
                        }}</span>
                      </div>
                    </div>
                  </td>

                  <!-- Time -->
                  <td
                    class="whitespace-nowrap px-4 py-3 align-middle"
                    [class.text-slate-400]="session.status === 'CANCELLED'"
                    [class.line-through]="session.status === 'CANCELLED'"
                    [class.text-slate-700]="session.status !== 'CANCELLED'"
                  >
                    {{ session.start_datetime | date : 'EEEE' : timeZone() }} &#64;
                    {{ session.start_datetime | date : 'h:mm a' : timeZone() }} -
                    {{ session.end_datetime | date : 'h:mm a' : timeZone() }}
                  </td>

                  <!-- Duration -->
                  <td
                    class="px-4 py-3 text-center align-middle"
                    [class.text-slate-400]="session.status === 'CANCELLED'"
                    [class.text-slate-700]="session.status !== 'CANCELLED'"
                  >
                    {{ session.duration }} min
                  </td>

                  <!-- Available Seats -->
                  <td
                    class="px-4 py-3 text-center align-middle"
                    [class.text-slate-400]="session.status === 'CANCELLED'"
                    [class.text-slate-700]="session.status !== 'CANCELLED'"
                  >
                    {{ session.max_participants - session.enrolled_count }}
                  </td>

                  <!-- Enrolled -->
                  <td
                    class="px-4 py-3 text-center align-middle"
                    [class.text-slate-400]="session.status === 'CANCELLED'"
                    [class.text-slate-700]="session.status !== 'CANCELLED'"
                  >
                    {{ session.enrolled_count }}/{{ session.max_participants }}
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        }
        <!-- /single_session -->
        <!-- multiple_session -->
        @if(this.course()?.course_mode === 'multiple_session') {
        <!-- Table Section -->
        @for(seriesItem of series(); track seriesItem.id; ){
        <div class="flex flex-col bg-white px-7 py-6 max-sm:px-3 max-sm:py-3">
          <div class="flex flex-col bg-white max-sm:py-3">
            <div>
              <div class="mb-1 flex flex-row items-center gap-2">
                <h5 class="text-slate-900" i18n>Series {{ getSeriesLetter($index) }}</h5>
                <!-- Series Status Badge -->
                @if (seriesItem.status) {
                <span
                  class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold"
                  [class.bg-green-100]="seriesItem.status === 'published'"
                  [class.text-green-600]="seriesItem.status === 'published'"
                  [class.bg-amber-100]="seriesItem.status === 'ready'"
                  [class.text-amber-600]="seriesItem.status === 'ready'"
                  [class.bg-slate-100]="seriesItem.status === 'draft'"
                  [class.text-slate-500]="seriesItem.status === 'draft'"
                >
                  <span class="h-1.5 w-1.5 rounded-full bg-current"></span>
                  <span class="capitalize">{{ seriesItem.status }}</span>
                </span>
                }
              </div>
            </div>

            <div class="w-full overflow-x-auto rounded-xl border border-slate-200 bg-white">
              <div class="flex items-center gap-4 rounded-md bg-white px-4 py-3 shadow-md">
                <!-- Available Days -->
                <div class="flex-1 font-medium text-slate-400">
                  <span i18n>
                    Available Days: <span class="text-black">{{ getAvailableDays(seriesItem) }}</span>
                  </span>
                </div>

                <!-- Available Seats -->
                <div class="flex flex-1 items-center justify-center gap-1 font-medium text-slate-400">
                  <svg-icon class="h-5 w-5" src="@assets/images/icons/checkmark-square.svg"></svg-icon>
                  <span i18n>
                    Available Seats:
                    <span class="text-black">{{ seriesItem.max_participants - seriesItem.enrolled_count }}</span>
                  </span>
                </div>
              </div>

              <table class="w-full min-w-[700px] text-sm">
                <thead class="bg-slate-50 text-xs">
                  <tr class="border-b border-slate-200">
                    <th class="p-4 text-left font-medium text-slate-600" i18n>Session</th>
                    <th class="p-4 text-left font-medium text-slate-600" i18n>Time</th>
                    <th class="p-4 text-center font-medium text-slate-600" i18n>Status</th>
                  </tr>
                </thead>

                <tbody>
                  @for(session of seriesItem.sessions; track session.id; let i = $index ){
                  <tr
                    class="border-b border-slate-100 transition"
                    [class]="session.status === 'CANCELLED' ? 'bg-red-50/50 hover:bg-red-50' : 'hover:bg-slate-50'"
                  >
                    <td class="px-3 py-2">
                      <div
                        class="flex flex-wrap items-center gap-2"
                        [class.opacity-60]="session.status === 'CANCELLED'"
                      >
                        <svg-icon class="h-4 w-4 text-slate-500" src="@assets/images/icons/calendar.svg"></svg-icon>
                        <span
                          class="text-sm font-medium"
                          [class.text-slate-400]="session.status === 'CANCELLED'"
                          [class.line-through]="session.status === 'CANCELLED'"
                          [class.text-slate-700]="session.status !== 'CANCELLED'"
                          >{{ session.start_datetime | date : 'dd MMMM' : timeZone() }}</span
                        >

                        <!-- Makeup icon (star-solid) -->
                        @if (session.is_make_up_class) {
                        <svg-icon
                          src="@assets/images/icons/star-solid.svg"
                          class="h-3.5 w-3.5 text-purple-500"
                          title="Makeup Session"
                        ></svg-icon>
                        }

                        <!-- Rescheduled icon (refresh) - show when rescheduled_from exists, rescheduled_to is null, and not cancelled -->
                        @if (session.rescheduled_from && !session.rescheduled_to && session.status !== 'CANCELLED') {
                        <svg-icon
                          src="@assets/images/icons/refresh.svg"
                          class="h-3.5 w-3.5 text-blue-600"
                          title="Rescheduled"
                        ></svg-icon>
                        }
                      </div>
                    </td>
                    <td
                      class="px-3 py-2"
                      [class.text-slate-400]="session.status === 'CANCELLED'"
                      [class.line-through]="session.status === 'CANCELLED'"
                      [class.text-slate-700]="session.status !== 'CANCELLED'"
                    >
                      {{ session.start_datetime | date : 'EEEE' : timeZone() }} &#64;
                      {{ session.start_datetime | date : 'h:mm a' : timeZone() }} -
                      {{ session.end_datetime | date : 'h:mm a' : timeZone() }}
                    </td>
                    <td class="px-3 py-2 text-center">
                      <!-- Temporal Status Badge (only for non-cancelled) -->
                      @if (session.status !== 'CANCELLED' && session.temporal_status) {
                      <span
                        class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold"
                        [class.bg-green-100]="session.temporal_status === 'upcoming'"
                        [class.text-green-600]="session.temporal_status === 'upcoming'"
                        [class.bg-slate-100]="session.temporal_status === 'completed'"
                        [class.text-slate-500]="session.temporal_status === 'completed'"
                        [class.bg-amber-100]="session.temporal_status === 'in_progress'"
                        [class.text-amber-600]="session.temporal_status === 'in_progress'"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-current"></span>
                        <span class="capitalize">{{ session.temporal_status }}</span>
                      </span>
                      }

                      <!-- Cancelled Badge -->
                      @if (session.status === 'CANCELLED') {
                      <span
                        class="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-600"
                      >
                        <span class="h-1.5 w-1.5 rounded-full bg-current"></span>
                        <span i18n>Cancelled</span>
                      </span>
                      }
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        } }
        <!-- /multiple_session -->

        }
      </div>
    </div>
    }
  </div>
</div>
}
